export enum PlatformAppConstants {
    HelpEmail = 'help-email',
}

export const PlatformAppConstantDefaults = {
    [PlatformAppConstants.HelpEmail]: 'info@firebend.com',
};
